document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("faq-searchInput");
  const faqs = document.querySelectorAll(".section-powershot-faqs-content_wrap .collapsible");

  input.addEventListener("input", function () {
    const query = input.value.toLowerCase();

    faqs.forEach(faq => {
      const question = faq.querySelector(".collapsible__title");
      const questionText = question ? question.textContent.toLowerCase() : "";

      faq.style.display = questionText.includes(query) ? "block" : "none";
    });
  });
});
